import store from '@/store';
import mainMenuService from '@/modules/layout/mainMenu/services/mainMenuService';

export const WEB_AI_WIDGET_APP_CODE_NAME = 'webaiwidgetmgr';
export const WEB_AI_WIDGET_FEATURE_FLAGS = [
  'rollout.online_presence.web_ai_widget',
];
export const FEATURE_FLAGS_TIMEOUT = 5000;

const areFeatureFlagsLoaded = () => store.getters['BusinessStore/featureFlagsLoaded'];

export const isWebAiWidgetFeatureEnabled = () => {
  if (!areFeatureFlagsLoaded()) return false;

  const hasFeature = store.getters['BusinessStore/hasFeature'];
  return WEB_AI_WIDGET_FEATURE_FLAGS.some((featureName) => hasFeature(featureName));
};

export const isWebAiWidgetInstalledInCache = () => {
  const cachedExternalApps = store.getters['MainMenuStore/externalApplications'] || [];
  return cachedExternalApps.some(
    (app) => app.app_code_name === WEB_AI_WIDGET_APP_CODE_NAME,
  );
};

export const isWebAiWidgetInstalled = async () => {
  if (isWebAiWidgetInstalledInCache()) return true;

  const externalApps = await mainMenuService.getExternalApplications();
  return externalApps.some((app) => app.app_code_name === WEB_AI_WIDGET_APP_CODE_NAME);
};

const waitForFeatureFlagsWithTimeout = async () => {
  if (areFeatureFlagsLoaded()) {
    return true;
  }

  let timeoutId;
  let unwatch;
  try {
    await Promise.race([
      new Promise((resolve) => {
        unwatch = store.watch(
          (state, getters) => getters['BusinessStore/featureFlagsLoaded'],
          (loaded) => {
            if (loaded) resolve();
          },
        );
      }),
      new Promise((resolve) => {
        timeoutId = setTimeout(resolve, FEATURE_FLAGS_TIMEOUT);
      }),
    ]);
  } finally {
    // Always release both resources, regardless of which promise won the race.
    if (timeoutId) clearTimeout(timeoutId);
    if (unwatch) unwatch();
  }

  return areFeatureFlagsLoaded();
};

export const isWebAiWidgetAvailable = async () => {
  const featureFlagsLoaded = await waitForFeatureFlagsWithTimeout();

  if (featureFlagsLoaded && isWebAiWidgetFeatureEnabled()) {
    return true;
  }

  return isWebAiWidgetInstalled();
};
